import { functions } from '../../config/firebase';

export const Authenticate = async () => {
  const authenticate = functions.httpsCallable('DecorateToken');
  const result = await authenticate();
  return result;
};
